import axios, { AxiosRequestConfig } from 'axios';
import jsonConstants from '../constants/jsonConstants';
const axiosInstance = axios.create({
  baseURL: jsonConstants.serverBaseUrl,
  timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' },
});
export const makeRequest = async <T>(config: AxiosRequestConfig) => axiosInstance.request<T>(config);
